<template>
  <div class="plv-ia-rpr-send">
    <div v-if="redPackCurrencyType === 'cashAndScore' || redpackPresetEnabled" class="plv-ia-rpr-send__pay-type">
      <template v-if="redPackCurrencyType === 'cashAndScore'">
        <div
          class="plv-ia-rpr-send__pay-type__item"
          :class="{
            'plv-ia-rpr-send__pay-type__item--active': curPayType === payTypes.cash,
          }"
          @click="curPayType = payTypes.cash"
        >
          <span>{{ t('plvIA.redpacketRain.sendCash') }}</span>
        </div>
        <div
          class="plv-ia-rpr-send__pay-type__item"
          :class="{
            'plv-ia-rpr-send__pay-type__item--active': curPayType === payTypes.point,
          }"
          @click="curPayType = payTypes.point"
        >
          <span>{{ t('plvIA.redpacketRain.sendPoint', {unit: pointUnit}) }}</span>
        </div>
      </template>
      <div v-if="redpackPresetEnabled" class="plv-ia-pre-rpr-back" @click="$emit('change-current-step', step.preRedpacket)">
        <span>{{ t('plvIA.redpacket.choosePreRedpacket')}}</span>
      </div>
    </div>
    <div v-show="curPayType === payTypes.point || redpackCashEnabled" class="plv-ia-rpr-send__body">
      <div class="plv-ia-rpr-send-type">
        <div
          class="plv-ia-rpr-send-type__item"
          :class="{ selected: tabVal === tabType.normal, 'plv-ia-rpr-send-type__item__disable': redpacketNormalDisable }"
          @click="tabChange(tabTypeKey.normal)"
        >
          {{ t('plvIA.redpacket.normalRedpacket') }}
        </div>
        <div
          class="plv-ia-rpr-send-type__item"
          :class="{ selected: tabVal === tabType.password, 'plv-ia-rpr-send-type__item__disable': redpacketPasswordDisable }"
          @click="tabChange(tabTypeKey.password)"
        >
          {{ t('plvIA.redpacket.passwordRedpacket') }}
        </div>
        <div
          class="plv-ia-rpr-send-type__item"
          :class="{ selected: tabVal === tabType.rain, 'plv-ia-rpr-send-type__item__disable': redpacketRainDisable }"
          @click="tabChange(tabTypeKey.rain)"
        >
          {{ t('plvIA.redpacket.redpacketRain') }}
        </div>
      </div>

      <div class="plv-ia-rpr-type">
        <span v-show="curType === rpTypes.equal">  {{ t('plvIA.redpacket.currentlyEquallyPacket') }}，</span>
        <span v-show="curType === rpTypes.random"> {{ t('plvIA.redpacket.currentlyLuckPacket') }}，</span>
        <span v-if="curType === rpTypes.equal" class="plv-ia-rpr-type-change" @click="tapType(rpTypes.random)">{{ t('plvIA.redpacket.changeLuckPacket') }}</span>
        <span v-else-if="curType === rpTypes.random" class="plv-ia-rpr-type-change" @click="tapType(rpTypes.equal)"> {{ t('plvIA.redpacket.changeEquallyPacket') }}</span>

        <span v-if="curPayType === payTypes.point" class="plv-ia-rpr-type__right">{{ t('plvIA.redpacket.canUsePoint', {unit: pointUnit}) }}{{ availableScore }}</span>
      </div>

      <!-- 拼手气红包 -->
      <send-random
        v-show="curType === rpTypes.random"
        ref="random"
        :curPayType="curPayType"
        :point-unit="pointUnit"
        :online-user-number="onlineUserNumber"
        :default-accounts="defaultAccounts"
        :max-total-amount="randomMaxTotalAmount"
        :available-score="availableScore"
        :max-count="randomMaxCount"
        @refresh-total="computedTotalAccount"
        @check-error="checkDataError"
      />
      <!-- 等分红包 -->
      <send-equal
        v-show="curType === rpTypes.equal"
        ref="equal"
        :curPayType="curPayType"
        :point-unit="pointUnit"
        :default-accounts="defaultAccounts"
        :single-max-amount="equalSingleMaxAmount"
        :single-max-count="equalSingleMaxCount"
        :max-total-amount="equalMaxTotalAmount"
        @refresh-total="computedTotalAccount"
        @check-error="checkDataError"
      />

      <div class="plv-ia-rpr-send__content">
        <cell
          v-if="tabVal === tabType.password"
          v-model="passwd"
          :title="t('plvIA.redpacket.redpacketPwd')"
          :placeholder="t('plvIA.redpacket.enterRedpacketPwd')"
          :max-len="20"
          cell-type="max"
          required
        />
        <cell
          v-if="tabVal === tabType.password"
          v-model="pwdGreeting"
          :title="t('plvIA.redpacketRain.pwdTip')"
          :placeholder="t('plvIA.redpacketRain.enterPwdTip')"
          :max-len="20"
          cell-type="max"
        />
        <cell
          v-else
          v-model="greeting"
          :title="t('plvIA.redpacketRain.coverText')"
          :max-len="20"
          cell-type="max"
        />
        <template v-if="joinInOption === 'word'">
          <cell
            v-model="passwd"
            title="设置口令"
            placeholder="请输入口令"
            cell-type="max"
            :max-len="20"
          />
          <cell
            v-model="passwdTip"
            title="口令提示"
            placeholder="请输入口令提示（非必填）"
            cell-type="max"
            :max-len="20"
          />
        </template>
      </div>
      <!-- 发放方式 -->
      <div class="plv-ia-rpr-send__content">
        <div class="plv-ia-rpr-cell">
          <div class="plv-ia-rpr-cell__left">
            <span class="plv-ia-rpr--required">*</span>
            {{ t('plvIA.redpacketRain.distribution') }}
          </div>
          <div class="plv-ia-rpr-cell__right">
            <input-select
              ref="sendRange"
              style="border: 1px solid #cfd8dc; box-sizing: border-box;"
              :options="sendRangeData"
              width="312px"
              default-index="0"
              :default-value="sendRangeValue"
              :option-tip="delayTimeTip"
              @select-index="selectRange"
            />
          </div>
        </div>
      </div>

      <!-- 发放方式-倒计时 -->
      <delay-time
        v-if="timeEnabled === 'Y'"
        v-model="delayTime"
        :cur-type="curType"
        :tab-val="tabVal"
        @change="checkDataError"
      />

      <div class="plv-ia-rpr-send__money">
        <button class="plv-ia-rpr-send__btn" :disabled="sendDisabled" @click="handleTapSend">
          {{ sendBtnText }}
        </button>
      </div>

      <template v-if="curPayType === payTypes.cash">
        <!-- 红包雨且在等分配置下，显示下述文案：-->
        <div v-if="curType === rpTypes.equal && tabVal === tabType.rain" class="plv-ia-rpr-send__tip">
          <p>1.{{ t('plvIA.redpacketRain.identicalRainTip1') }}</p>
          <p>2.{{ t('plvIA.redpacketRain.identicalRainTip2') }}</p>
          <p>3.{{ t('plvIA.redpacketRain.identicalRainTip3') }}</p>
          <p>4.{{ t('plvIA.redpacketRain.identicalRainTip4') }}</p>
        </div>

        <!-- 普通红包、口令红包且在等分配置下，显示下述文案：-->
        <div v-if="curType === rpTypes.equal && tabVal !== tabType.rain" class="plv-ia-rpr-send__tip">
          <p>1.{{ t('plvIA.redpacketRain.identicalOtherTip1') }}</p>
          <p>2.{{ t('plvIA.redpacketRain.identicalOtherTip2') }}</p>
          <p>3.{{ t('plvIA.redpacketRain.identicalOtherTip3') }}</p>
          <p>4.{{ t('plvIA.redpacketRain.identicalOtherTip4') }}</p>
        </div>

        <!-- 普通红包、口令红包、红包雨在拼手气配置下，显示下述文案：-->
        <div v-if="curType === rpTypes.random" class="plv-ia-rpr-send__tip">
          <p>1.{{ t('plvIA.redpacketRain.randomTip1') }}</p>
          <p>2.{{ t('plvIA.redpacketRain.randomTip2') }}</p>
          <p>3.{{ t('plvIA.redpacketRain.randomTip3') }}</p>
          <p>4.{{ t('plvIA.redpacketRain.randomTip4') }}</p>
        </div>
      </template>

      <template v-if="curPayType === payTypes.point">
        <!-- 积分红包，显示下述文案： -->
        <div class="plv-ia-rpr-send__tip">
          <p>1.{{ t('plvIA.redpacketRain.pointTip1') }}</p>
        </div>
      </template>
    </div>

    <!--  现金红包被禁用后，显示下述文案：-->
    <div v-show="!(curPayType === payTypes.point || redpackCashEnabled)" class="plv-ia-pre-rpr-tip--empty">
      {{ t('plvIA.redpacket.recpackTipEmpty') }}
    </div>
  </div>
</template>

<script>
import {
  EQUAL_MIN_TOTAL_ACCOUNT,
  EQUAL_MIN_TOTAL_SCORE,
  EQUAL_MAX_TOTAL_ACCOUNT,
  SINGLE_MIN_ACCOUNT,
  SINGLE_MIN_SCORE,
  RANDOM_MIN_TOTAL_ACCOUNT,
  RANDOM_MIN_TOTAL_SCORE,
  DEFAULT_DATA,
  DEFAULT_ACCOUNTSCN,
  DEFAULT_ACCOUNTSEN,
  DEFAULT_POINT_ACCOUNTSCN,
  DEFAULT_POINT_ACCOUNTSEN,
  DEFAULT_DELAY_LIMIT,
  step
} from '../config';
import Cell from './cell';
import SendRandom from './send-random';
import SendEqual from './send-equal';
import InputSelect from '@/components/inputSelect';
import DelayTime from './delay-time.vue';
import Locale from '@/mixins/locale';
import commonMixin from '../../app-mixin';
import redpacketBaseData from '../mixins/redpacket-base-data';
import inputLimit from '../mixins/inputLimit';

export default {
  name: 'RedpackSend',
  components: {
    Cell,
    SendRandom,
    SendEqual,
    InputSelect,
    DelayTime
  },
  mixins: [Locale, commonMixin, redpacketBaseData, inputLimit],
  props: {
    /** 红包雨SDK 实例 */
    core: {
      type: Object,
      default: null
    },
    /** 红包开关配置 */
    redpacketConfig: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 在线人数
    onlineUserNumber: {
      type: Number,
      default: 0
    },
    delayDisable: {
      type: Boolean,
      default: false
    },
    lang: {
      type: String,
      default: 'zh_CN'
    },
    scoreRedPackEnabled: {
      type: String,
    },
    pointUnit: {
      type: String,
    },
    redpackPresetEnabled: {
      type: Boolean
    },
    redpackCashEnabled: {
      type: Boolean
    },
    redPackCurrencyType: {
      type: String,
    }
  },

  data() {
    return {
      step,
      curPayType: 'cash', // 支付类型，cash-现金，point-积分
      tabVal: 'OFFICIAL_NORMAL', // tab 选项值
      curType: 0, // 当前红包类型
      passwd: '', // 红包口令
      dataIsError: true, // 红包数值是否有错误
      totalAccount: '0.00', // 显示的总金额
      ...DEFAULT_DATA,
      greeting: this.t('plvIA.redpacketRain.bestWishes'),
      pwdGreeting: '',
      availableScore: 0, // 当前可用积分
      delayTime: 3, // 倒计时时间 默认为3分钟
      timeEnabled: 'N', // 定时红包开关，Y:开启，N：关闭
      sendRangeValue: '', // 发放方式
      sendRangeData: [] // 发放方式的中英文
    };
  },
  computed: {
    defaultAccounts() {
      let accounts = [];
      switch (this.curPayType) {
        case this.payTypes.cash:
          accounts = this.lang === 'en' ? DEFAULT_ACCOUNTSEN : DEFAULT_ACCOUNTSCN;
          break;
        case this.payTypes.point:
          accounts = this.lang === 'en' ? DEFAULT_POINT_ACCOUNTSEN : DEFAULT_POINT_ACCOUNTSCN;
          break;
      }
      return accounts;
    },
    // 定时红包的提示
    delayTimeTip() {
      if (this.delayDisable) {
        return this.t('plvIA.redpacketRain.waitDelay');
      } else {
        return null;
      }
    },
    sendDisabled() {
      // 数量有问题 或 没有封面文字
      return this.dataIsError || !this.greeting;
    },
    redpacketNormalDisable() {
      return !this.redpacketConfig.includes(this.tabTypeKey.normal);
    },
    redpacketRainDisable() {
      return !this.redpacketConfig.includes(this.tabTypeKey.rain);
    },
    redpacketPasswordDisable() {
      return !this.redpacketConfig.includes(this.tabTypeKey.password);
    },
    equalMaxAmount() {
      return typeof this.equalMaxTotalAmount === 'number' && this.equalMaxTotalAmount > 0 ? this.equalMaxTotalAmount : EQUAL_MAX_TOTAL_ACCOUNT;
    },
    // 按钮文本
    sendBtnText() {
      if (this.curPayType === this.payTypes.point) {
        return `${this.t('plvIA.redpacket.putScore')} ${this.totalAccount} ${this.pointUnit || this.t('plvIA.redpacketRain.score')}`;
      }
      return `${this.t('plvIA.redpacket.putMoney')} ${this.totalAccount} ${this.t('plvIA.redpacketRain.cny')}`;
    },
  },
  watch: {
    redPackCurrencyType: {
      handler(val) {
        if (val === this.payTypes.point) {
          this.curPayType = this.payTypes.point;
        } else {
          this.curPayType = this.payTypes.cash;
        }
      },
      immediate: true
    },
    passwd: {
      handler() {
        this.checkDataError();
      },
    },
    // 默认设置红包类型
    redpacketConfig: {
      handler() {
        if (!this.redpacketNormalDisable) {
          this.tabVal = this.tabType.normal;
        } else if (!this.redpacketPasswordDisable) {
          this.tabVal = this.tabType.password;
        } else if (!this.redpacketRainDisable) {
          this.tabVal = this.tabType.rain;
        }
      },
      immediate: true
    },
    delayDisable(val) {
      if (val) {
        this.disableSendDelay();
      }
      this.initSendRangeData();
    },
    lang() {
      this.greeting = this.t('plvIA.redpacketRain.bestWishes');
      this.sendRangeValue = this.t('plvIA.redpacketRain.immediate');
      this.initSendRangeData();
    },
    curPayType: {
      handler() {
        if (this.curPayType === this.payTypes.point) {
          this.getScoreLimit();
        }
        this.$refs.random && this.$refs.random.resetData();
        this.$refs.equal && this.$refs.equal.resetData();
      },
      immediate: true,
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.computedTotalAccount();
    });
    if (this.delayDisable) {
      this.disableSendDelay();
    }
    this.initSendRangeData();
  },

  methods: {
    /** 获取当前积分状态 */
    async getScoreLimit() {
      const data = await this.core.getRedpacketScore();
      this.availableScore = data.availableScore || data.totalScore - data.usedScore || 0;
    },

    // 红包类型是否禁用
    redpacketTypeDisable(type) {
      return !this.redpacketConfig.includes(type);
    },
    // 禁用定时红包
    disableSendDelay() {
      this.sendRangeValue = this.t('plvIA.redpacketRain.immediate');
      this.$refs.sendRange.select(this.sendRangeData[0], 0);
      this.timeEnabled = 'N';
    },
    // 初始化发放方式的选项
    initSendRangeData() {
      this.sendRangeData = [
        { label: this.t('plvIA.redpacketRain.immediate'), value: 'N' },
        {
          label: this.t('plvIA.redpacketRain.countdownDistribution'),
          value: 'Y',
          disable: this.delayDisable
        }
      ];
    },
    // 下拉框 选择发放方式
    selectRange(index) {
      this.timeEnabled = this.sendRangeData[index].value;
      this.checkDataError();
    },
    // 检查是否存在红包数值错误
    checkDataError(showToast = true) {
      this.dataIsError = false;
      // 检查定时时间符合规定
      if (this.timeEnabled === 'Y' && this.delayTime < DEFAULT_DELAY_LIMIT.min) {
        this.dataIsError = true;
        this.$iaMessage.default(
          this.t('plvIA.redpacketRain.minDelayLimit') +
            DEFAULT_DELAY_LIMIT.min +
            this.t('plvIA.redpacketRain.minutes')
        );
        return;
      } else if (this.timeEnabled === 'Y' && this.delayTime > DEFAULT_DELAY_LIMIT.max) {
        this.dataIsError = true;
        this.$iaMessage.default(
          this.t('plvIA.redpacketRain.maxDelayLimit') +
            DEFAULT_DELAY_LIMIT.max +
            this.t('plvIA.redpacketRain.minutes')
        );
        return;
      }
      switch (this.curType) {
        // 拼手气检测
        case this.rpTypes.random: {
          this.checkRandomError(showToast);
          break;
        }
        // 等分红包检测
        case this.rpTypes.equal: {
          this.checkEqualError(showToast);
          break;
        }
        default:
          break;
      }
    },

    // 检查拼手气红包金额
    checkRandomError(showToast) {
      const randomCtx = this.$refs.random;
      const { curAccount, rpCount } = randomCtx;

      if (this.tabVal === this.tabType.password && !this.passwd) {
        this.dataIsError = true;
      }

      if (curAccount === '') {
        this.dataIsError = true;
        return;
      }

      switch (this.curPayType) {
        case this.payTypes.cash:
          this.checkRandomCashError(showToast, curAccount, rpCount);
          break;
        case this.payTypes.point:
          this.checkRandomPointError(showToast, curAccount, rpCount);
          break;
      }

      if (!curAccount || !rpCount) {
        this.dataIsError = true;
        return;
      }

      if (Number.parseInt(rpCount) === 0) {
        this.totalAccount = 0;
        this.dataIsError = true;
      }
    },

    /** 检查拼手气现金红包 */
    checkRandomCashError(showToast, curAccount, rpCount) {
      // 检查红包金额最小值
      if (curAccount < RANDOM_MIN_TOTAL_ACCOUNT) {
        this.dataIsError = true;
        showToast &&
          this.$iaMessage.default(
            `${this.t('plvIA.redpacketRain.taost2')}${RANDOM_MIN_TOTAL_ACCOUNT}`
          );
        return;
      }

      // 检查最低平分金额
      if (curAccount / rpCount < SINGLE_MIN_ACCOUNT) {
        this.dataIsError = true;
        showToast &&
          this.$iaMessage.default(
            this.t('plvIA.redpacketRain.toast4', { t: SINGLE_MIN_ACCOUNT })
          );
      }
    },

    /** 检查拼手气积分红包 */
    checkRandomPointError(showToast, curAccount, rpCount) {
      // 积分是否超出可用值
      if (curAccount > this.availableScore) {
        this.dataIsError = true;
        showToast &&
          this.$iaMessage.default(
            `${this.t('plvIA.redpacketRain.toast5')}${this.availableScore}`
          );
        return;
      }

      // 红包数量需要小于可用积分数
      if (rpCount > this.availableScore) {
        this.dataIsError = true;
        showToast &&
          this.$iaMessage.default(
            `${this.t('plvIA.redpacketRain.toast6')}`
          );
        return;
      }

      // 检查红包积分最小值
      if (curAccount < this.availableScore && curAccount < RANDOM_MIN_TOTAL_SCORE) {
        this.dataIsError = true;
        showToast &&
          this.$iaMessage.default(
            `${this.t('plvIA.redpacketRain.taost9')}${RANDOM_MIN_TOTAL_SCORE}`
          );
        return;
      }

      // 检查最低平分积分
      if (curAccount < this.availableScore && curAccount / rpCount < SINGLE_MIN_SCORE) {
        this.dataIsError = true;
        showToast &&
          this.$iaMessage.default(
            this.t('plvIA.redpacketRain.toast8', { t: SINGLE_MIN_SCORE })
          );
      }
    },

    // 等分红包金额保留两位小数，向上取整
    formateNumber(target) {
      return Math.ceil(target * 100) / 100;
    },

    // 等分红包计算手续费
    computedPoundage(account) {
      if (this.curPayType === this.payTypes.point) {
        return account;
      }
      return account / 0.98;
    },

    // 检查等分红包是否异常
    checkEqualError(showToast) {
      const equalCtx = this.$refs.equal;
      const { rprList } = equalCtx;
      let totalAccount = this.getEqualTotalAccount(rprList);
      totalAccount = this.computedPoundage(totalAccount);
      totalAccount = this.formateNumber(totalAccount);

      // 检查口令红包
      if (this.tabVal === this.tabType.password && !this.passwd) {
        this.dataIsError = true;
      }

      switch (this.curPayType) {
        case this.payTypes.cash:
          this.checkEqualCashError(showToast, totalAccount);
          break;
        case this.payTypes.point:
          this.checkEqualPointError(showToast, totalAccount);
          break;
      }
    },

    checkEqualCashError(showToast, totalAccount) {
      // 检查红包总金额最小值
      if (totalAccount < EQUAL_MIN_TOTAL_ACCOUNT) {
        this.dataIsError = true;
        showToast &&
          this.$iaMessage.default(
            `${this.t('plvIA.redpacketRain.taost2')}${EQUAL_MIN_TOTAL_ACCOUNT}`
          );
        return;
      }

      // 检查红包总金额最大值
      if (totalAccount > this.equalMaxAmount) {
        this.dataIsError = true;
        showToast &&
          this.$iaMessage.default(`${this.t('plvIA.redpacketRain.taost1')}${this.equalMaxAmount}`);
      }
    },

    checkEqualPointError(showToast, totalAccount) {
      // 检查红包总积分最小值
      if (totalAccount < EQUAL_MIN_TOTAL_SCORE) {
        this.dataIsError = true;
        showToast &&
          this.$iaMessage.Redpacket(
            `${this.t('plvIA.redpacketRain.taost9')}${EQUAL_MIN_TOTAL_SCORE}`
          );
        return;
      }

      // 检查红包总积分最大值
      if (totalAccount > this.availableScore) {
        this.dataIsError = true;
        showToast &&
          this.$iaMessage.Redpacket(
            `${this.t('plvIA.redpacketRain.toast5')}${this.availableScore}`
          );
      }
    },

    // 计算红包总值
    computedTotalAccount() {
      let totalAccount = 0;
      switch (this.curType) {
        case this.rpTypes.random:
          totalAccount = this.$refs.random.curAccount;
          break;
        case this.rpTypes.equal: {
          const rprList = this.$refs.equal.rprList;
          totalAccount = this.getEqualTotalAccount(rprList);
          totalAccount = this.computedPoundage(totalAccount);
          break;
        }
        default:
          break;
      }
      if (!totalAccount) {
        this.totalAccount = this.curPayType === this.payTypes.point ? '0' : '0.00';
        return;
      }

      this.totalAccount = this.formateNumber(totalAccount).toString();
    },

    // 计算等分红包输入的总金额
    getEqualTotalAccount(rprList) {
      let totalAccount = 0;
      rprList.forEach(item => {
        const { account, total } = item;
        if (account && total) {
          totalAccount += account * total;
        }
      });
      return totalAccount;
    },

    toast(message, duration = 1500) {
      return this.$iaMessage.default({ message, duration });
    },

    tabChange(key) {
      if (!this.redpacketTypeDisable(key)) {
        this.tabVal = this.tabType[key];
        this.checkDataError(false);
      } else {
        this.$iaMessage.default(this.t('plvIA.redpacket.connectGM'));
      }
    },

    tapType(type) {
      // TODO: 是否需要记住切换前的数据.
      Object.keys(DEFAULT_DATA).forEach(key => {
        this[key] = DEFAULT_DATA[key];
      });
      this.greeting = this.t('plvIA.redpacketRain.bestWishes');

      this.curType = type;
      this.$nextTick(() => {
        this.computedTotalAccount();
        this.checkDataError(false);
      });
    },

    filterAmountOrScore(num) {
      switch (this.curPayType) {
        case 'cash':
          return parseInt(num * 100);
        case 'point':
          return parseInt(num);
      }

      return parseInt(num);
    },

    // 获取红包类型
    getRedpackType() {
      const isPoint = this.curPayType === this.payTypes.point;
      // 如果是发积分则前缀加 SCORE_
      if (isPoint) {
        return `SCORE_${this.tabVal}`;
      }
      return this.tabVal;
    },

    // 发送红包
    handleTapSend() {
      // 判断参数
      const params = {
        redPackType: this.getRedpackType(),
        greeting: this.tabVal === this.tabType.password ? this.pwdGreeting : this.greeting,
        passwd: this.passwd,
        redPackAllotType: this.curType ? 'average' : 'random',
      };

      if (this.timeEnabled === 'Y') {
        params.minutes = this.delayTime;
      }

      // 拼手气参数
      if (this.curType === this.rpTypes.random) {
        switch (this.curPayType) {
          case this.payTypes.cash:
            params.amount = this.filterAmountOrScore(this.totalAccount);
            break;
          case this.payTypes.point:
            params.score = this.filterAmountOrScore(this.totalAccount);
            break;
        }
        params.count = this.$refs.random.rpCount;
      }

      // 等分红包参数
      if (this.curType === this.rpTypes.equal) {
        const { rprList } = this.$refs.equal;
        const redPackSendAverage = [];
        rprList.forEach((item) => {
          if (item.total && item.account) {
            const averageItem = {
              redPackCount: item.total,
            };
            switch (this.curPayType) {
              case this.payTypes.cash:
                averageItem.redPackAmount = this.filterAmountOrScore(item.account);
                break;
              case this.payTypes.point:
                averageItem.redPackScore = this.filterAmountOrScore(item.account);
                break;
            }

            redPackSendAverage.push(averageItem);
          }
        });
        params.redPackSendAverage = redPackSendAverage;
      }

      this.$emit('on-send', params, this.curPayType);
    }
  }
};
</script>

<style lang="scss">
body[data-lang=en] {
  .plv-ia-rpr-send__body {
    width: 480px;
  }
}
.plv-ia-rpr-send {
  min-height: 520px;
}
.plv-ia-rpr-send__body {
  width: 430px;
  margin: 0 auto;
}
.plv-ia-rpr-send__pay-type {
  width: 100%;
  height: 40px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-top: 4px;
}
.plv-ia-pre-rpr-back:hover {
  cursor: pointer;
}
.plv-ia-pre-rpr-back {
  position: absolute;
  right: 0;
  display: flex;
  align-items: center;
  top: 50%;
  margin-top: -12px;
  line-height: 24px;
  color: #4caaf5;
  span {
    transform: translateY(1px);
  }
  .plv-ia-pre-rpr-back-icon {
    display: inline-block;
    width: 24px;
    height: 24px;
    background-image: url('../images/icon-back.png');
    background-size: 100% 100%;
  }
}
.plv-ia-rpr-send__pay-type__item {
  margin-right: 16px;
  margin-left: 16px;
  font-size: 14px;
  color: #546E7A;
  cursor: pointer;
  height: 40px;

  & > span {
    line-height: 40px;
  }

  &.plv-ia-rpr-send__pay-type__item--active {
    color: #2196F3;
    border-bottom: 2px solid #2196F3;
  }
}

.plv-ia-rpr-send-type {
  margin: 20px 0;
  display: flex;
  justify-content: center;
  &__item {
    // width: 94px;
    padding: 0 12px;
    text-align: center;
    line-height: 32px;
    height: 32px;
    border-radius: 2px;
    color: #333;
    font-size: 14px;
    border: 1px solid #cfd8dc;
    cursor: pointer;
    &:first-of-type {
      border-right: none;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    &:last-of-type {
      border-left: none;
      border-top-left-radius: 0;
      border-bottom-right-radius: 0;
    }
    &.selected {
      color: #fff;
      background: #2196f3;
      border-color: #2196f3;
    }
  }
}
.plv-ia-rpr-send__content {
  padding: 0 0 0 0;
}
.plv-ia-rpr-cell-delayTip {
  color: #9e9e9e;
  font-size: 12px;
  position: relative;
  display: flex;
  align-items: center;
  img {
    width: 14px;
    height: 14px;
  }
  span {
    margin-left: 10px;
  }
}

.plv-ia-rpr-send__money {
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  p {
    margin: 20px 0;
    font-size: 30px;
    strong {
      margin-left: 6px;
      font-size: 40px;
    }
  }
  button {
    font-size: 14px;
    outline: none;
    border: none;
    background: #ff5b5b;
    height: 36px;
    line-height: 36px;
    text-align: center;
    border-radius: 18px;
    color: #fff;
    padding: 0 20px;
    cursor: pointer;
    &:disabled {
      cursor: not-allowed;
      background: rgba(255, 91, 91, 0.5);
    }
  }
  .plv-ia-rpr-send__money__tips {
    display: inline-block;
    width: 14px;
    height: 14px;
    position: relative;
    &:before {
      display: inline-block;
      position: absolute;
      top: 0;
      left: 0;
      line-height: 1;
      content: '';
      width: 14px;
      height: 14px;
      background: url('../images/icon-tip.png') no-repeat;
      background-size: cover;
    }
  }
}

.plv-ia-rpr-send__tip {
  margin-left: 20px;
  position: relative;
  p {
    font-size: 12px;
    line-height: 18px;
    color: #9e9e9e;
  }
  &:before {
    content: '';
    position: absolute;
    left: -18px;
    width: 14px;
    height: 14px;
    background: url('../images/icon-tip.png') no-repeat;
    background-size: cover;
    // line-height: 14px;
    // text-align: center;
    // box-sizing: border-box;
    // border-radius: 100%;
    // color: #757575;
    // border: 1px solid #757575;
    top: 2px;
  }
}
.plv-ia-rpr-type {
  padding-left: 12px;
}
.plv-ia-rpr-type-change {
  color: #4caaf5;
  cursor: pointer;
}

.plv-ia-rpr-type__right {
  float: right;
  margin-right: 20px;
}

.plv-ia-rpr-send__btn {
  margin-top: 24px;
}
.plv-ia-rpr--required {
  color: #ff3a30 !important;
}
.plv-ia-rpr-send-type__item__disable {
  color: #9e9e9e !important;
  cursor: not-allowed;
}
.plv-ia-pre-rpr-tip--empty {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 100px;
}
</style>
